import React, { useEffect, useState, createContext, useContext } from "react" 
import { useParams, useSearchParams } from "react-router-dom"
import { appTools, cn, queryTools } from "lib/utils"
import { useAppCtx, appStore } from "lib/state"
import { makeNewConditional } from "lib/utils/conditionals"
import { ContentEditor } from "lib/units/content"
import { useStatements } from "lib/units/dispute/statements"

// const ConditionalContext = createContext({})
// export const useConditionalCtx = () => useContext(ConditionalContext)

const newConditional = { name: "", description: "", zones: [], items: [] }

export default function ContentWrapper({ 
  usage="local",
  elemtype,
  children 
}:{ 
  usage?:"local" | "global";
  elemtype?:string;
  children?:React.ReactNode 
}):JSX.Element {
  
  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams() 

  const { appState, appTools }:any = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })
  // const { data:_Snippets } = queryTools.resource.parseQueryForApi("content.findAll", { snippet: true }, { enabled: true })
  const saveFn = queryTools.resource.save(["content.all"])

  const [ currentContent, setCurrentContent ] = useState<any>(null)

  async function handleContentSave(e:any, data:any){
    if(e) e.preventDefault()
    console.log(data)
    saveFn.mutate({ resource: "content", data: {...data, _id: data._id} })
  }

  const updateContent = (data:any) => {
    console.log("data", data)
    if( !data ) data = makeNewConditional()
    if( usage === "local" ){
      return update("actives.statement.content", {...store.actives.statement.content, ...data })
    } else {
      return update("actives.content", {...store.actives.content, ...data })
    }
  }

  useEffect(() => {
    let current 
    if( usage === "local" ){
      if( !store.actives.statement.content ){
        const content = makeNewConditional()
        update("actives.statement.content", content)
        current = content
      } else {
        current = store.actives.statement.content
      }
    } else if (usage === "global"){
      if( !store.actives.content ){
        const content = makeNewConditional()
        update("actives.content", content)
        current = content
      } else {
        current = store.actives.content
      }
    }
    setCurrentContent(current)
  },[store.actives.statement?.content, store.actives.content, usage])

  useEffect(() => {
    if( _Dispute && searchParams.get("st") ){
      console.log(elemtype)
      const statement = _Dispute?.elements.find( (elem:any) => elem.refstr === elemtype)?.settings.config.find( (st:any) => st.refstr === searchParams.get("st") )
      if( statement ){
        update("actives.statement", statement)
      }
    }
  },[_Dispute, searchParams.get("st")])

  return (
    <div className="w-full h-full relative">
      <div className="w-full h-full flex flex-col grow">
        { searchParams.get("ctype") !== null && (
          <ContentEditor
            elemtype={elemtype || ""}
            ctype={searchParams.get("ctype") || ""}
            value={ store.actives.statement.content[searchParams.get("ctype") || ""] }
            changeFn={ (value:string) => {
              update(`actives.statement.content.${searchParams.get("ctype")}`, value) 
            }}
          />
        )}
      </div>
    </div>
  )
}
